/**
 * Check if we is on a market with northstar enabled
 * @return {boolean} true if is Nort Star, else false
 */
import getCookie from '../getCookie';
import { getLocale } from '../locale';
const isNorthStarEnabled = () => {
    const locale = getLocale(null, 'en_gb', null, { useAEMLocaleInfo: true });
    const isNSEnabled = !!(process.env.IS_NORTHSTAR_ENABLED === 'enabled' && /^da[-_]dk$/gi.test(locale));
    // Below is to make sure the local env is working without the cookie solution in place
    // To disable local environment:  process.env.NODE_ENV === 'development' to disabled Local
    const isCookieSolutionEnabled = process.env.NODE_ENV !== 'development';
    const getNSCookie = getCookie('hm-ns-dk-enabled') === 'true';
    if (isCookieSolutionEnabled) {
        return isNSEnabled && getNSCookie;
    }
    return !!isNSEnabled;
};
export default isNorthStarEnabled;
//# sourceMappingURL=isNorthStarEnabled.js.map